import * as React from "react";
import {cs} from "../../../../../../../../react/chain-services";
import "./section-mapping.scss";
import {Fields} from "./fields/fields";
import {UseState} from "../../../../../../../../react/use-state";

export const SectionMapping = ({ fileName, columns, countryCode, rows, keys, next}) => cs(
    ["fields", (_, next) => Fields({
        keys,
        columns,
        countryCode,
        next,
    })],
    ({fields}) => next({
        invalid: fields.invalid,
        highlightErrors: fields.highlightErrors,
        render: ({showErrors}) => cs(
            ["rowIndex", (_, next) => UseState({initValue: 0, next})],
            ({rowIndex}) => (
                <div className="section-mapping section-mapping-63d">
                    <div className="header">
                        <div className="title">
                            <div className="text" xd-qa-type="label" xd-qa-name="Build Address List File Analyzing...">
                                File Analyzing...
                            </div>
                            <div className="file-name" xd-qa-type="label" xd-qa-name="Build Address List File Name">
                                {fileName}
                            </div>
                        </div>

                        <div className="sub-title" xd-qa-type="label" xd-qa-name="Build Address List File Analyzing Description">
                            Our system analyzed your file and selected the fields below. Please examine the address shown here and correct it if necessary.
                        </div>
                    </div>

                    <div className="box">
                        {fields.render({
                            row: rows[rowIndex.value],
                            showErrors,
                        })}

                        <div className="controls">
                            <button {...{
                                disabled: rowIndex.value === 0,
                                onClick: () => rowIndex.change(v=>v-1),
                                "xd-qa-type": "button",
                                "xd-qa-name": "Build Address List Prev Address",
                            }}>
                                PREV ADDRESS
                            </button>

                            <button {...{
                                disabled: rowIndex.value === rows.length - 1,
                                onClick: () => rowIndex.change(v=>v+1),
                                "xd-qa-type": "button",
                                "xd-qa-name": "Build Address List Next Address",
                            }}>
                                NEXT ADDRESS
                            </button>
                        </div>
                    </div>
                </div>
            ),
        ),
    }),
);